import axios from "axios";
import API_URL from "../config/apiConfig";

const restaurantHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

// Backend errors come as { error: { message } } (errorHandler) or { message }.
export const clubErrorMessage = (error, fallback = "خطایی رخ داد. دوباره تلاش کنید.") =>
  error?.response?.data?.error?.message || error?.response?.data?.message || fallback;

// ---- Owner ----

export const getClubCustomers = (restaurantId) =>
  axios
    .get(`${API_URL}/api/club/${restaurantId}/customers`, { headers: restaurantHeaders() })
    .then(({ data }) => data);

export const getClubCustomer = (restaurantId, customerId) =>
  axios
    .get(`${API_URL}/api/club/${restaurantId}/customers/${customerId}`, { headers: restaurantHeaders() })
    .then(({ data }) => data);

export const createClubCustomer = (restaurantId, customer) =>
  axios
    .post(`${API_URL}/api/club/${restaurantId}/customers`, customer, { headers: restaurantHeaders() })
    .then(({ data }) => data.customer);

export const updateClubCustomer = (restaurantId, customerId, changes) =>
  axios
    .patch(`${API_URL}/api/club/${restaurantId}/customers/${customerId}`, changes, { headers: restaurantHeaders() })
    .then(({ data }) => data);

export const deleteClubCustomer = (restaurantId, customerId) =>
  axios.delete(`${API_URL}/api/club/${restaurantId}/customers/${customerId}`, { headers: restaurantHeaders() });

// ---- Public (guest joins from the online menu) ----

export const getPublicMenuInfo = (menuLink) =>
  axios.get(`${API_URL}/api/menus/public/${menuLink}`).then(({ data }) => ({
    restaurant: data.restaurant,
    customerClubEnabled: Boolean(data.customerClubEnabled),
  }));

export const requestClubJoinCode = (restaurantId, phone) =>
  axios.post(`${API_URL}/api/club/${restaurantId}/join/request-code`, { phone }).then(({ data }) => data);

export const verifyClubJoinCode = (restaurantId, payload) =>
  axios.post(`${API_URL}/api/club/${restaurantId}/join/verify`, payload).then(({ data }) => data);
